import { IMenuItem } from "./IMenuItem";
import { UNKNOWN_MENU_INDEX } from "./const";

export function addTrackingToNavigation(navigation: IMenuItem[]): IMenuItem[] {
  let depth = 0,
    universe = "";

  navigation.forEach((menuItem: IMenuItem) => {
    universe = menuItem.title;
    iterateMenu(menuItem, depth, universe);
  });

  return navigation;
}

function iterateMenu(menuItem: IMenuItem, depth: number, universe: string) {
  menuItem.tracking = _generateNavTrackingText(menuItem.title, depth, universe);
  if (menuItem.children) {
    menuItem.children.forEach((menuItem: IMenuItem) => {
      iterateMenu(menuItem, depth + 1, universe);
    });
  }
}

export function locateMenuIndexForPath(
  menuItems: IMenuItem[],
  path: string
): number {
  // report if given menu item or any of its children match the given path. Note that it is possible for a menuItem
  // link to have params, so we turn it into a url then get the path.
  function hasPath(menuItem: IMenuItem): boolean {
    if (new URL(menuItem.link, window.location.href).pathname == path) {
      return true;
    }

    return (
      menuItem.children.filter((menuItem: IMenuItem) => {
        return hasPath(menuItem);
      }).length > 0
    );
  }

  for (let i = 0; i < menuItems.length; i++) {
    if (hasPath(menuItems[i])) {
      return i;
    }
  }

  return UNKNOWN_MENU_INDEX;
}

export function locateMenuIndexByHeuristic(
  menuItems: IMenuItem[],
  path: string
): number {
  const paths: string[] = path.split("/");

  if (paths.find(p => p === "business")) {
    return menuItems.findIndex(menuItem => menuItem.title === "For Business");
  }

  return UNKNOWN_MENU_INDEX;
}

export function _generateNavTrackingText(
  title: string,
  depth: number,
  universe: string
): string {
  return `fly:${
    depth === 0 ? "for home" : universe
  }:l${depth}:${title.trim()}`.toLowerCase();
}

export function getLogoLink(
  trackedMenus: IMenuItem[],
  activeIndex: number
): string {
  let logoLink;
  // If the top level nav item is "For Business" & its active: return the business link
  trackedMenus.forEach((trackedMenuItem, index) => {
    if (trackedMenuItem.title === "For Business" && activeIndex === index) {
      logoLink = trackedMenuItem.link;
    }
  });
  return logoLink || "/";
}
